import { Component, OnInit } from '@angular/core';
import { IFilterFilters } from '../ifilter';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { Datalistrequestfilter } from '../../request/datalistrequestfilter';

@Component({
  selector: '[app-hotel-reservation-permit-type-filter]',
  templateUrl: './hotel-reservation-permit-type-filter.component.html',
  styleUrls: ['./hotel-reservation-permit-type-filter.component.scss'],
  host: { 'class': 'control' },
  standalone: false,
})
export class HotelReservationPermitTypeFilterComponent implements OnInit, IFilterFilters {
  public loading = false;
  public permitTypes: HotelReservationPermitType[] = [];
  public selectedPermitTypeId: number = 0;
  public Filters: Datalistrequestfilter[] = [];
  public FilterName: string = "permitType";
  public QueryParamPrefix: string = "";

  constructor(private apiService : ApiServiceBase) {}
 

  async ngOnInit(): Promise<void> {
    this.loading = true;
    try {
      this.permitTypes = await this.apiService.Get<HotelReservationPermitType[]>("permits/hotelreservationpermittypes");
    } catch (error) {
      console.error('Failed to load hotel reservation permit types for filter', error);
    } finally {
      this.loading = false;
    }
  }

  public addPermitTypeFilter(event: any) {
    const val = event.target.value;
    this.Filters = this.Filters.filter(x => x.Property !== "ParkingPermitTypeId");

    if (val !== "" && val !== 0 && val !== "0") {
      this.Filters.push({
        Property: "ParkingPermitTypeId",
        Comparator: "==",
        Value: val,
        FilterName: this.FilterName
      });
      this.selectedPermitTypeId = val;
    } else {
      this.selectedPermitTypeId = 0;
    }
  }
}

export interface HotelReservationPermitType {
  Id: number;
  Name: string;
}

